module.exports = {"pipeline":{"name":"pipeline-scaleQuestion","title":"量表题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-scaleQuestion/package.json
// module id = 578
// module chunks = 2